$(document).ready(function() {
    'use strict';

    /**
     * Displays a tooltip for the given input element.
     *
     * @param {HTMLElement} inputElement - The input element for which the tooltip is displayed.
     */
    function showTooltip (inputElement) {
        let position = inputElement.offset();
        $('#xss-tooltip').css({
            top: position.top + inputElement.outerHeight() + 5,
            left: position.left
        });

        $('#xss-tooltip').fadeIn();
    }

    function hideTooltip () {
        if ($('.xss-tooltip').is(':visible')) {
            $('#xss-tooltip').fadeOut();
        }
    }

    if ($('#XSSSanitizationValidationEnabled').val() === true || $('#XSSSanitizationValidationEnabled').val() === 'true') {
        $(document).on('input', 'input, textarea', function() {
            let eventAttributesRegex = /<script[^>]*>.*<\/script>|<[^>]*(on\w+\s*=[^>]*>)/i;
            if (eventAttributesRegex.test($(this).val())) {
                showTooltip($(this));
            } else {
                hideTooltip();
            }
        });

        $(document).on('focusout', 'input, textarea', function() {
            hideTooltip();
        });

        document.addEventListener('scroll', (event) => {
            hideTooltip();
        });

        $('.modal-container').on('scroll', () => {
            hideTooltip();
        });
    }
});
